import { EventEmitter, ViewContainerRef } from '@angular/core';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { FilterComponentFactory } from '@irian-ro/table-column-filter';
import { DateTimeRangeContextMenuFilterComponent } from './date-time-range-context-menu-filter.component';

export interface InputOptions {
  props?: {
    placeholder?: string;
    value?: {start: Date | null, end: Date | null};
  };
  filterChangeEvent?: EventEmitter<FilterMetadata>;
}

export const dateTimeRangeContextMenuFactory: FilterComponentFactory<DateTimeRangeContextMenuFilterComponent> = {
  createInstance: (container: ViewContainerRef) => {
    return container.createComponent<DateTimeRangeContextMenuFilterComponent>(DateTimeRangeContextMenuFilterComponent).instance;
  },

  bindProps: (instance: DateTimeRangeContextMenuFilterComponent, options?: InputOptions) => {
    instance.placeholder.set(options?.props?.placeholder ?? '');
    instance.value.set(options?.props?.value ?? {start: null, end: null});
  },

  subscribeToChanges: (instance: DateTimeRangeContextMenuFilterComponent, options?: InputOptions) => {
    instance.filtersChange.subscribe((filters: FilterMetadata) => {
      if(options?.filterChangeEvent) {
        options.filterChangeEvent.emit(filters);
      }
    })
  }
}
